// extracted by mini-css-extract-plugin
export var checkIcon = "_c-2";
export var heading = "_c-1";
export var panel = "_c-0";